import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Activité récente',
  actions: {
    clicked: 'Cliqué',
    open: 'Ouvert',
    scheduled: 'Planifié',
    sent: 'Envoyé',
  },
  fields: {
    recipients: '{{recipients}} destinataires',
    opened: '{{rate}} ouverts',
    clicked: '{{rate}} cliqués',
    awaiting: 'En attente de confirmation',
  },
  template_types: TemplateNames,
};
